import { UIBindings, UIProvider } from '@intelingu/core/components/provider/UIProvider';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import "reflect-metadata";
import { I18nextProvider } from 'react-i18next';
import App from './components/App';
import { config, initializeConfig } from 'config';
import { bindings } from './components/bindings';
import './IoC/inversify.config';
import i18n from './configs/i18n.config';
import * as Sentry from '@sentry/browser';

const renderApp = (App) => ReactDOM.render((
    <UIProvider bindings={bindings}>
        <I18nextProvider i18n={ i18n }>
            <App />
        </I18nextProvider>
    </UIProvider>
), document.getElementById('app'));

(async () => {
    await initializeConfig();

    Sentry.init({dsn: config.sentry});

    renderApp(App);
})();
